import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from './onboarding.reducer';

export const ONBOARDING_STORE_KEY = 'ONBOARDING';

export const getOnboardingState =
  createFeatureSelector<fromReducer.IOnboardingState>(ONBOARDING_STORE_KEY);

// ------- ONBOARDING GLOBAL STATE:

export const getOnboardingPageState = createSelector(
  getOnboardingState,
  (state) => state
);
